import { MouseEventHandler } from "react";

type ModalHeaderProps = {
  title: string;
  showCloseIcon?: boolean;
  className?: string;
  onClose?: MouseEventHandler;
};
const ModalHeader = ({
  title,
  showCloseIcon = true,
  className = "",
  onClose = () => {},
}: ModalHeaderProps) => {
  return (
    <div className={`sticky top-0 py-8 z-10 ${className}`} style={{ backgroundColor: 'var(--bg-surface)' }}>
      {showCloseIcon && (
        <img
          src="/assets/icons/cross.svg"
          alt="close"
          className="ltr:float-right rtl:float-left cursor-pointer"
          onClick={(event) => onClose(event)}
        ></img>
      )}
      <h3 className="text-2xl" style={{ color: 'var(--text-main)' }}>{title}</h3>
    </div>
  );
};
export default ModalHeader;
